import { StatefulPopoverProps } from 'baseui/popover';
import { StatefulPopover as BaseStatefulPopover } from '@tigergraph/app-ui-lib/popover';

export function StatefulTipsPopover(props: StatefulPopoverProps) {
  return <BaseStatefulPopover {...props} />;
}
